import { useJourney } from '../journey';
import { takesStatement } from '../screens';
import { CheckState, Checklist, Loading } from '../ui/Parts';
import Shell from '../ui/Shell';

/** While identity checks, statement analysis and scoring run; the session is polled until there is a decision. */
const Assessing = () => {
  const { steps, current, session, close } = useJourney();
  const statementPending = takesStatement(session) && session.statement?.status !== 'ANALYSED';
  const checksDone = session.status !== 'VERIFICATION_PENDING' && !statementPending;
  const items: { label: string; state: CheckState }[] = [
    { label: 'Customer information received', state: 'done' },
    { label: 'Required checks completed', state: checksDone ? 'done' : 'active' },
    { label: 'Calculating your eligibility', state: checksDone ? 'active' : 'todo' },
  ];

  return (
    <Shell steps={steps} current={current} onClose={close}>
      <div className="rounded-xl border border-lend-line px-4 py-8 md:py-10 text-center shadow-sm">
        <Loading />
        <h2 className="text-lg md:text-xl font-semibold">Assessing your eligibility</h2>
        <p className="mt-2 text-sm md:text-base text-lend-body">
          We&apos;re reviewing your information to determine the financing amount available to you.
        </p>
        <div className="mt-5">
          <Checklist items={items} />
        </div>
      </div>
    </Shell>
  );
};

export default Assessing;
